import Constant from '../common/Constant';
import { userActions, uiActions } from './index';
import Analytics from '../analytics/Analytics';
import Events from '../analytics/Events';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

const moment = require('moment');

function updateUser(dispatch, currentUser, timer, newTimer) {
  const user = {
    timer: newTimer,
  };

  dispatch(userActions.settingsUpdated(user));

  firebase
    .firestore()
    .collection('users')
    .doc(currentUser.uid)
    .set(user, { merge: true })
    .catch(() => {
      user.timer = timer;
      dispatch(userActions.settingsUpdated(user));
    });
}

function startTimer(project, timer) {
  const data = JSON.stringify({
    name: project.name,
    notes: project.notes,
    hourlyRate: project.hourlyRate,
    currencyCode: project.currencyCode,
  });
  Analytics.logEvent(Events.START_TIMER, { project: data });

  return dispatch => {
    const { currentUser } = firebase.auth();
    if (currentUser) {
      const newTimer = {
        status: Constant.TIMER_RUNNING,
        projectId: project.id,
        startAtMillis: moment().valueOf(),
        millisRecorded: timer.millisRecorded,
      };

      updateUser(dispatch, currentUser, timer, newTimer);
    }
  };
}

function stopTimer(project, timer) {
  const data = JSON.stringify({
    name: project.name,
    notes: project.notes,
    hourlyRate: project.hourlyRate,
    currencyCode: project.currencyCode,
  });
  Analytics.logEvent(Events.STOP_TIMER, { project: data });

  return dispatch => {
    const { currentUser } = firebase.auth();
    if (currentUser) {
      const newTimer = {
        status: Constant.TIMER_PAUSED,
        projectId: project.id,
        startAtMillis: 0,
        millisRecorded:
          timer.millisRecorded + (moment().valueOf() - timer.startAtMillis),
      };

      updateUser(dispatch, currentUser, timer, newTimer);
    }
  };
}

function discardTimerLog(timer) {
  return dispatch => {
    const { currentUser } = firebase.auth();
    if (currentUser) {
      const newTimer = {
        status: Constant.TIMER_NOT_RUNNING,
        projectId: '',
        startAtMillis: 0,
        millisRecorded: 0,
      };

      updateUser(dispatch, currentUser, timer, newTimer);
      dispatch(uiActions.timerProjectClicked(''));
    }
  };
}

export const timerActions = {
  startTimer,
  stopTimer,
  discardTimerLog,
};



// WEBPACK FOOTER //
// ./src/actions/timer.js